/* eslint-disable max-len */
import React, { useCallback, useMemo } from 'react';
import { useSessionStorage } from 'react-use';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ColorGroups } from '../../../ui';
import { ColorButton } from '../../../ui/ColorButton';
import { KeepPopoutWidgetOpenButton } from '../../../ui/KeepOpenButton';
import { Position } from '../../../ui/Position';
import { useResolve } from '../../Container';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { ElementSelector } from '../../canvas/ui/ElementSelector';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { FrameElementSelectorItems } from '../frame/FrameElementSelectorItems';
import { ZoneElementSelectorItems } from '../zones/ZoneElementSelectorItems';

const { ItemGroup, ItemSet, Item, ItemPreview } = ElementSelector;

const createModel = (color: string) => [
    ItemGroup('zones', 'Zones', 'deqo://icons/d2/zone', [
        ItemSet('zones', 'Zones', 2, ZoneElementSelectorItems(color)),
    ]),
    ...FrameElementSelectorItems(color),
];

export const LayoutLibraryWidget = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);
    const defaultColor = ColorGroups[3][3];
    const [color, setColor] = useSessionStorage('deqo/ui/layoutWidget/color', defaultColor);

    const onSelect = useCallback((item: any, selectMode: 'drag' | 'click') => {
        widget.update({ open: !widget.autoClose });

        const toolId =
            (item.id.startsWith('zones') ? 'zoneTool' : null) ??
            (item.id.startsWith('frames') ? 'frameTool' : null) ??
            (item.id.startsWith('layouts') ? 'layoutTool' : null) ??
            'default';

        const mode = selectMode === 'click' ? 'drag' : 'drop';
        const opt = !item.props.value ? 'edit' : '';

        tools.setSettings(toolId, item.props);
        dispatch(toolEquip, [toolId, `${mode}:${opt}`]);

    }, [color]);

    const model = useMemo(() => createModel(color), [color]);

    return <Flexer relative width="24">
        <ElementSelector name="text" model={model} onSelectItem={onSelect} />
        <Position inset=".6" at="topRight">
            <Flexer flex="row" align="center" gap=".5">
                <ColorButton value={color} autoSelect groups onChange={setColor} />
                <KeepPopoutWidgetOpenButton widget={widget} />
            </Flexer>
        </Position>
    </Flexer>;
});

export const LayoutLibraryWidgetOldDawg = React.memo<{ widget: PopoutWidget }>(({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);
    const defaultColor = ColorGroups[3][3];
    const [color, setColor] = useSessionStorage('deqo/ui/layoutWidget/color', defaultColor);

    const onSelect = useCallback((item: any, selectMode: 'drag' | 'click') => {
        widget.update({ open: !widget.autoClose });

        const toolId =
            (item.id.startsWith('zones') ? 'zoneTool' : null) ??
            (item.id.startsWith('frames') ? 'frameTool' : null) ??
            (item.id.startsWith('layouts') ? 'layoutTool' : null) ??
            'default';

        const mode = selectMode === 'click' ? 'drag' : 'drop';
        const opt = !item.props.value ? 'edit' : '';

        tools.setSettings(toolId, item.props);
        dispatch(toolEquip, [toolId, `${mode}:${opt}`]);

    }, [color]);

    const model = useMemo(() => createModel(color), [color]);

    return <Flexer relative width="24">
        <ElementSelector name="text" model={model} onSelectItem={onSelect} />
        <Position inset=".6" at="topRight">
            <Flexer flex="row" align="center" gap=".5">
                <ColorButton value={color} autoSelect groups onChange={setColor} />
                <KeepPopoutWidgetOpenButton widget={widget} />
            </Flexer>
        </Position>
    </Flexer>;
});
